export const zIndex = {
  modal: 1001
}